import React from 'react';
import { COLORS } from '../../constants';
import './Input.css';

const Input = ({ 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  className = '', 
  style = {},
  ...props 
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`prisma-input ${className}`}
      style={style}
      {...props}
    />
  );
};

export default Input;